import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: { 
    user: null,
    token: null,
    isAuthenticated: false,
    value: { email: "", password: "" , header:false } 
  },
  reducers: {
    login: (state, { payload }) => {
      state.user = payload.user;
      state.token = payload.token;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.value = { email: "", password: "" };
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      // Clear persisted data from localStorage on logout
      if (typeof window !== 'undefined') {
        localStorage.removeItem('persist:root');
      }
    },
    setLayout: (state, { payload }) => {
      state.layout = payload;
    },
    setToogleHeader: (state, { payload }) => {
      state.header = payload;
    },
  },
});

export const { login, logout, setLayout , setToogleHeader} = userSlice.actions;
export default userSlice.reducer;
